export default __webpack_public_path__ + "static/media/financialHealth.06bd0609.jpg";